<template>
  <el-form
    class="form"
    ref="form"
    label-width="100px"
    :model="form"
    :rules="rules"
    :disabled="disabled"
  >
    <el-form-item label="审核状态" prop="reviewStatus">
      <el-select v-model="form.reviewStatus" @change="handleChange">
        <el-option v-for="(label, key) in reviewStatusMap" :value="+key" :key="+key" :label="label"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="更新方式">
      <el-select v-model="form.updateAction" :disabled="form.reviewStatus !== 1">
        <el-option v-for="(label, key) in updateMap" :value="+key" :key="+key" :label="label"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="申诉类型" v-if="form.reviewStatus === 1">
      <el-select v-model="form.appealType">
        <el-option v-for="(label, key) in appealTypeMap" :value="+key" :key="+key" :label="label"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="对接商务" prop="transferUser" v-if="form.reviewStatus === 3">
      <el-input v-model="form.transferUser"></el-input>
    </el-form-item>

    <el-form-item label="补充材料信息" prop="reason" v-if="form.reviewStatus === 4">
      <el-input v-model="form.reason" type="textarea"></el-input>
    </el-form-item>

    <el-form-item label="原因" prop="reason" v-if="form.reviewStatus === 2">
      <el-input v-model="form.reason" type="textarea"></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { reviewStatusMap, updateMap, appealTypeMap } from '../../const'
import { omit } from 'lodash-es'

export default {
  name: 'AuditForm',
  props: {
    track: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      updateMap,
      appealTypeMap,
      reviewStatusMap: omit(reviewStatusMap, ['0']),
      disabled: false,
      form: {
        reviewStatus: '',
        updateAction: 1,
        appealType: '',
        transferUser: '',
        reason: ''
      },
      rules: {
        reviewStatus: {
          required: true, message: '请选择审核状态'
        },
        appealType: {
          required: true, message: '请选择申诉类型'
        },
        reason: {
          required: true, message: '请填写'
        },
        transferUser: {
          required: true, message: '请填写'
        }
      },
    }
  },

  created() {
    if (this.track.reviewStatus !== 0) {
      Object.keys(this.form).forEach(key => {
        this.form[key] = this.track[key]
      })
      this.disabled = true
    }
  },

  methods: {
    async getData() {
      await this.$refs.form.validate()
      return {
        ...this.form
      }
    },
    handleChange() {
      this.form.transferUser = ''
      this.form.reason = ''
      this.form.appealType = ''
      this.form.updateAction = 1
    }
  }
}

</script>

<style scoped>
.form {
  width: 400px;
}
</style>
